import { selectActualFeatureFlags } from 'containers/App/selectors'

import { WHITELIST_FOR_TYPES } from './constants'

const selectData = (state) => state.settings.whitelist.self.data
const selectLoader = (state) => state.settings.whitelist.self.loader
const selectError = (state) => state.settings.whitelist.self.error
const selectSelectedIds = (state) => state.settings.whitelist.self.selectedIds

const selectAddFormLoader = (state) => state.settings.whitelist.self.addFormLoader
const selectAddFormError = (state) => state.settings.whitelist.self.addFormError

const selectEditFormLoader = (state) => state.settings.whitelist.self.editFormLoader
const selectEditFormError = (state) => state.settings.whitelist.self.editFormError

const selectByCompanyTypeFilter = (state) => state.settings.whitelist.self.byCompanyTypeFilter
const selectByCompanySortProperty = (state) => state.settings.whitelist.self.byCompanySortProperty

const selectSearchFilter = (state) => state.settings.whitelist.self.search
const selectWhitelistPage = (state) => state.settings.whitelist.self.page
const selectTableLoader = (state) => state.settings.whitelist.self.tableLoader

const selectItemWhitelistTypes = (state) => {
  const ff = selectActualFeatureFlags(state)
  const whitelistKeys = Object.keys(WHITELIST_FOR_TYPES)

  // Filter out the "LINKS" type and "SPAM" type if the feature flag is disabled
  // Also filter the "bypass link from being clicked" option -->
  // since its not relevant in new item but only in new link
  const whitelistedTypes = whitelistKeys.filter(
    (key) =>
      WHITELIST_FOR_TYPES[key] !== WHITELIST_FOR_TYPES.BYPASS_ALL_LINKS &&
      WHITELIST_FOR_TYPES[key] !== WHITELIST_FOR_TYPES.LINKS &&
      (ff.ENABLE_SPAM_FILTER || WHITELIST_FOR_TYPES[key] !== WHITELIST_FOR_TYPES.SPAM)
  )

  return whitelistedTypes
}

export {
  selectData,
  selectLoader,
  selectError,
  selectSelectedIds,
  selectAddFormLoader,
  selectAddFormError,
  selectEditFormLoader,
  selectEditFormError,
  selectByCompanyTypeFilter,
  selectByCompanySortProperty,
  selectItemWhitelistTypes,
  selectSearchFilter,
  selectWhitelistPage,
  selectTableLoader,
}
